import React from 'react';
import { Flex, Button } from '@decisiv/ui-components';

const PERIODS = [
  { id: 'day', label: 'Day' },
  { id: 'week', label: 'Week' },
  { id: 'month', label: 'Month' },
  { id: 'all', label: 'All Time' },
];

// Full-page navigation with a `?period=` query param — the controller
// re-renders fresh props, so no client-side fetch/state is needed here.
// `q`/`searchField`/`groupBy` (if present) are preserved across period
// switches.
const PeriodSelector = ({
  period,
  basePath,
  q = '',
  searchField = '',
  groupBy = '',
}) => (
  <Flex gap={1} marginBottom={2}>
    {PERIODS.map((p) => (
      <Button
        key={p.id}
        text={p.label}
        kind={p.id === period ? 'primary' : 'secondary'}
        size="small"
        onClick={() => {
          const params = new URLSearchParams({ period: p.id });
          if (groupBy) params.set('group_by', groupBy);
          if (q) {
            params.set('q', q);
            if (searchField) params.set('search_field', searchField);
          }
          window.location.href = `${basePath}?${params.toString()}`;
        }}
      />
    ))}
  </Flex>
);

export default PeriodSelector;
